import { TableColumnsSetting } from '@/interfaces/table-setting';
import { LoyaltyModel } from '@/models/imports/loyalty-model';

export class LoyaltySettingsTable {
  public static getColumnsSetting(): TableColumnsSetting<keyof LoyaltyModel> {
    return [
      {
        name: 'id',
        text: 'Id',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'importId',
        text: 'Import Id',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'frame',
        text: 'Telaio',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'seller',
        text: 'Venditore',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'fiscalCodeVatNumberCustomer',
        text: 'Codice Fiscale/PIVA cliente',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'customer',
        text: 'Cliente',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'createdAt',
        type: 'datetime',
        text: 'creato il',
        filter: {
          type: 'dateRange',
        },
      },
      {
        name: 'updatedAt',
        type: 'datetime',
        text: 'modificato il',
        filter: {
          type: 'dateRange',
        },
      },
    ];
  }
}
